<template>
  <a-modal
    title="操作日志详情"
    v-model:visible="openView"
    @cancel="onCloseView"
    :width="800"
    :maskClosable="false"
    :keyboard="false"
    :destroyOnClose="true"
    :footer="null"
    class="view-form-modal"
  >
    <a-descriptions title="操作信息" layout="vertical" :column="2">
      <a-descriptions-item label="操作模块">
        {{ form.title }}
      </a-descriptions-item>
      <a-descriptions-item label="登录信息">
        {{ form.operName }} / {{ form.operIp }} / {{ form.operLocation }}
      </a-descriptions-item>
      <a-descriptions-item label="请求地址">
        {{ form.operUrl }}
      </a-descriptions-item>
      <a-descriptions-item label="操作方法" span="2">
        <div style="word-break: break-all">{{ form.method }}</div>
      </a-descriptions-item>
      <a-descriptions-item label="请求方式">
        {{ form.requestMethod }}
      </a-descriptions-item>
    </a-descriptions>
    <a-descriptions title="接口信息" layout="vertical">
      <a-descriptions-item label="请求参数" span="3">
        {{ form.operParam }}
      </a-descriptions-item>
      <a-descriptions-item label="返回参数" span="3">
        {{ form.jsonResult }}
      </a-descriptions-item>
      <a-descriptions-item label="操作状态" span="1">
        <a-badge v-if="form.status === 1" status="processing" text="正常" />
        <a-badge v-if="form.status === 0" status="error" text="失败" />
      </a-descriptions-item>
      <!--      <a-descriptions-item label="消耗时间" span="1">-->
      <!--        {{ form.costTime }} 毫秒-->
      <!--      </a-descriptions-item>-->
      <a-descriptions-item label="操作日期" span="1">
        {{ parseTime(form.operTime) }}
      </a-descriptions-item>
      <a-descriptions-item label="异常信息" span="3" v-if="form.status === 1">
        {{ form.errorMsg }}
      </a-descriptions-item>
    </a-descriptions>
  </a-modal>
</template>

<script>
import { parseTime } from '@/utils/ruoyi'

export default {
  name: 'ViewForm',
  props: {},
  data() {
    return {
      // 表单参数
      form: {},
      openView: false,
    }
  },
  created() {},
  computed: {},
  watch: {},
  methods: {
    parseTime,
    handleView(row) {
      this.openView = true
      this.form = row
    },
    onCloseView() {
      this.openView = false
    },
  },
}
</script>

<style>
/* Modal body 样式 */
.view-form-modal .ant-modal-body {
  padding: 20px 24px !important;
  max-height: 70vh;
  overflow-y: auto;
}

/* Descriptions 样式 */
.view-form-modal .ant-descriptions {
  margin-bottom: 24px;
}

.view-form-modal .ant-descriptions-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
}
</style>
